export default __webpack_public_path__ + "static/media/close-circle.b84b0c44.svg";